module.exports = __webpack_public_path__ + "img/membership_mt.1e1190b2.gif";